export default "__VITE_ASSET__BydjdF0w__"